'use client';
import { jsx } from 'react/jsx-runtime';
import { renderWithRef } from '../core/render-with-ref.js';
import { RenderComp } from '../core/render-comp.component.js';

const PriceBarVat = renderWithRef('PriceBarVat', null, (t, a)=>{
    let { children: o } = t;
    return jsx(RenderComp, {
        root: "div",
        forwardedRef: a,
        classNames: new Set([
            'swan-price-bar-vat'
        ]),
        props: t,
        children: o
    });
});

export { PriceBarVat };
